import { useCallback, useState } from 'react';
import { useNavigationComponent } from 'navigation-components/application/hooks';
import Raven from 'raven-js';
import { ACADEMY_PIP_SESSION_KEY, academyVideoHostComponentDef } from 'navigation-components/config';
import { useAsyncEffect } from 'react-utils/hooks/useAsyncEffect';
export const useAcademyVideoHost = () => {
  const [isAcademyVideoHostOpen, setIsAcademyVideoHostOpen] = useState(false);
  const {
    show,
    getState,
    hide
  } = useNavigationComponent({
    componentDef: academyVideoHostComponentDef
  });
  useAsyncEffect(async () => {
    const state = await getState();
    if (state) {
      setIsAcademyVideoHostOpen(!!state.isOpen);
    }
  }, [getState]);
  const showAcademyVideoHost = useCallback(async () => {
    if (!isAcademyVideoHostOpen) {
      await show();
    }
  }, [show, isAcademyVideoHostOpen]);
  const hideAcademyVideoHost = useCallback(async () => {
    try {
      sessionStorage.removeItem(ACADEMY_PIP_SESSION_KEY);
    } catch (error) {
      Raven.captureException(error);
    }
    setIsAcademyVideoHostOpen(false);
    await hide();
  }, [hide]);
  return {
    showAcademyVideoHost,
    hideAcademyVideoHost
  };
};